import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AppContext from "../../../AppContext";
import * as Library from "../../../utils/Library";
import InfinityGridSidePanelBOImages from "../cardContainers/InfinityGridSidePanelBOImages";
import SidePanelLinkedCard from "./SidePanelLinkedCard";
import BtnLargeSolidInverted02 from "../buttons/BtnLargeSolidInverted02";
import { useNavigate } from "react-router";
import useDebounce from "../../../utils/hooks/useDebounce";
import Upload02 from "@untitled-ui/icons-react/build/esm/Upload02";
import magnifierIcon from "../../../assets/icons/magnifierIcon.png";

/* #region SCOPED CSS */
const StyledPage = styled.div`
    &.SidePanel {
        width: 422px;
        height: 100%;
        z-index: 999;
        position: absolute;
        top: 0;
        right: -389px;
        display: inline-flex;
        align-items: center;
        overflow: hidden;
        z-index: 9999;
        transition: transform 0.5s;
    }

    &.SidePanel.active {
        transform: translate3d(-389px, 0, 0);
    }

    &.SidePanel.noOverflow {
        overflow: hidden;
        width: 33px;
        right: 0;
    }

    .PanelContainer {
        width: 389px;
        height: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 32px;
        display: inline-flex;
        //background-color: var(--backgrounds-lines-n-200);
        background-color: #10141b;
        box-shadow: 0px -2px 10px 0px rgba(17, 22, 32, 0.8);

        display: flex;
        padding: 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .Frame313346 {
        width: 33px;
        height: 143px;
        justify-content: flex-start;
        align-items: center;
        display: inline-flex;
        position: relative;
        cursor: pointer;
    }

    .Rectangle300 {
        width: 2px;
        height: 16px;
        background: white;
        border-radius: 24px;
        position: absolute;
        right: 33px;
    }

    .Group3497 {
        display: flex;
        flex-shrink: 0;
        width: 33px;
        height: 143px;
        position: relative;
    }

    .Rectangle253 {
        width: 29px;
        height: 143px;
        position: absolute;
        right: 0px;
        top: 0px;
    }

    .ItemsPanel {
        width: 143px;
        height: 16px;
        position: absolute;
        top: 143px;
        right: -127px;
        margin: 0 5px 0 8px;
        text-align: center;
        transform: rotate(-90deg);
        transform-origin: 0px 0px;
        color: rgb(209, 209, 209);

        font-family: Roboto;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.21px;
        text-transform: uppercase;
    }

    .Frame313271 {
        width: 100%;
        height: 100%;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
        display: inline-flex;
    }

    .Frame313329 {
        align-self: stretch;
        justify-content: center;
        align-items: center;
        gap: 8px;
        display: inline-flex;
    }

    .Settings01 {
        width: 24px;
        height: 24px;
        position: relative;
    }

    .Products {
        flex: 1 1 0;
        text-align: center;
        color: #d1d1d1;
        font-size: 20px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    .XClose {
        width: 24px;
        height: 24px;
        position: relative;
    }

    .Frame313276 {
        width: 100%;
        height: 100%;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;
        display: flex;
    }

    .Frame313330 {
        align-self: stretch;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        display: inline-flex;
    }

    .Search {
        flex: 1 1 0;
        height: 37px;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        display: flex;
        align-items: center;
        position: relative;
    }

    .SearchList {
        font-size: 12px;
        font-family: Roboto;
        font-style: italic;
        font-weight: 400;
        word-wrap: break-word;
        border: none;
        line-height: normal;
        position: relative;
    }

    .Frame48 {
        flex: 1 1 0;
        height: 37px;
        padding: 6px 12px;
        background: #1e2631;
        border-radius: 4px;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        display: flex;
        outline: none;
        color: var(--text-icons-gray-100);
    }

    .IconSearch {
        width: 40px;
        height: 37px;
        justify-content: center;
        align-items: center;
        display: flex;
    }

    .Frame29 {
        width: 40px;
        height: 37px;
        padding: 10px;
        background: #1e2631;
        border-radius: 4px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        display: inline-flex;
    }

    .Frame29.disabled,
    .Frame29.disabled svg {
        color: var(--text-icons-gray-300);
        cursor: not-allowed;
    }

    .Upload02 {
        position: relative;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .SearchIcon {
        position: absolute;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        right: 12px;
    }

    .SearchIcon img {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .Frame313333 {
        align-self: stretch;
        height: calc(100% - 37px);
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;
        display: flex;
        margin-right: -15px;
    }

    .TabsMainWindow {
        align-self: stretch;
        justify-content: center;
        align-items: flex-start;
        gap: 16px;
        display: inline-flex;
    }

    .Frame313332 {
        flex: 1 1 0;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
        display: inline-flex;
    }

    .Ellipse6 {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #00aeef;
        margin-left: 4px;
        position: relative;
        top: 3px;
    }

    .LinkedProducts {
        display: inline-flex;
        align-self: center !important;
    }

    .ListItem {
        cursor: pointer;
        font-size: 10px;
        font-family: Roboto;
        font-weight: 500;
        letter-spacing: 0.12px;
        text-transform: uppercase;
        color: #d1d1d1;
        word-wrap: break-word;
        align-self: stretch;
        text-align: center;
    }

    .Line5 {
        visibility: hidden;
        align-self: stretch;
        height: 0px;
        border: 1px #00aeef solid;
    }

    .Frame313332.active .Line5,
    .Frame313332:hover .Line5 {
        visibility: visible;
    }

    .Frame313332.active .ListItem,
    .Frame313332:hover .ListItem {
        color: #00aeef;
    }

    .ListItem2 {
        border: 1px solid transparent;
        border-radius: 4px;
    }

    .ListItem2:hover,
    .ListItem2.active {
        border: 1px solid var(--text-icons-blue-500, #00aeef);
    }

    .Frame313311 {
        align-self: stretch;
        height: 1210px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        display: flex;

        overflow-y: scroll;
        overflow-x: hidden;

        margin-right: 0px;
        padding-right: 7px;
    }

    .InfiniteScrollContainer {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 24px;
        overflow-y: hidden;
        //background: #00aeef;
        position: relative;
    }

    /* .Frame313311 > div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
} */
`;

const NoProductsWarningStyled = styled.div`
    &.frame-313311,
    &.frame-313311 * {
        box-sizing: border-box;
    }
    &.frame-313311 {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .items-panel-product-card {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px 8px 8px 8px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-173 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313312 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313313 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313326 {
        padding: 10px 0px 10px 0px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313323 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .you-don-t-have-any-products-to-link-select-how-you-want-to-import-products {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .frame-313328 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        height: 38px;
        position: relative;
    }
    .frame-313324 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 35px;
        position: relative;
    }
    .frame-295922380 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-large-solid-inverted-02 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 141px;
        position: relative;
    }
    .btn-small-filled {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 140px;
        position: relative;
    }
    .via-file {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: left;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
    .via-server {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
`;
/* #endregion */

/**
 * Renders the Products Side Panel.
 * This component uses the AppContext to get the sidePanelVisible and sidePanelProducts states
 *
 * @component
 * @returns {jsx} Products Side Panel
 */
export default function ProductsSidePanel() {
    /* #region USE STATES */
    const navigate = useNavigate();
    const {
        BOTagsList,
        setBOTagsList,
        sidePanelIsLoading,
        sidePanelVisible,
        setSidePanelVisible,
        sidePanelProducts,
        sidePanelRetailBrandID,
        sidePanelHasNewLinkedProducts,
        setSidePanelHasNewLinkedProducts,
        setSidePanelSection,
        sidePanelSection,
        sidePanelProductSearchName,
        setSidePanelProductSearchName,
        setBrandNotSelectedShowError,
        sidePanelHasNoProducts,
        setShowAddProductsPopup,
        setBOImageProductsImporting,
        setSidePanelSelectedProductNumber
    } = React.useContext(AppContext);

    const [searchTmpName, setSearchTmpName] = useState("");
    const debouncedText = useDebounce(searchTmpName, 500);
    /* #endregion */

    /* #region USE EFFECTS */
    // SIDE PANEL VISIBILITY UI CHANGES, when the sidePanelVisible state changes (OK)
    // side effect: when closing the side panel, all BOtags will be unselected
    useEffect(() => {
        //sidePanelProducts.length === 0
        if (sidePanelVisible && !sidePanelRetailBrandID) {
            Library.showErrorMessage("Please select the desired brand for this BOimage");
            setSidePanelVisible(false);
            setBrandNotSelectedShowError(true);
            return;
        }

        document.querySelector(".SidePanel").classList.toggle("active", sidePanelVisible);

        if (!sidePanelVisible) {
            setTimeout(() => {
                document.querySelector(".SidePanel").classList.toggle("noOverflow", true);
                document.querySelector(".PanelContainer").classList.toggle("hidden", true);
            }, 500);

            setBOTagsList(BOTagsList.map(tag => ({ ...tag, selected: false })));
            setSidePanelSelectedProductNumber(undefined);
        } else {
            document.querySelector(".SidePanel").classList.toggle("noOverflow", false);
            document.querySelector(".PanelContainer").classList.toggle("hidden", false);

            //LISTEN FOR OUTSIDE CLICKS TO CLOSE THE SIDE PANEL
            const handleClickOutside = event => {
                if (
                    event.target.closest(".SidePanel") === null &&
                    event.target.closest(".BotagBeacon") === null &&
                    event.target.closest(".ItemsPanelProductCard") === null &&
                    event.target.closest(".Toastify") === null &&
                    event.target.closest(".CardBox") === null &&
                    event.target.closest(".btn-large") === null
                ) {
                    setSidePanelVisible(false);
                } else if (event.target.closest(".BotagBeacon") !== null) {
                    let selectBotagNumber = null;
                    if (event.target.closest(".beaconSelected") === null) {
                        selectBotagNumber = event.target.closest(".BotagBeacon").getAttribute("data-botag-number");
                        if (selectBotagNumber) selectBotagNumber = parseInt(selectBotagNumber);

                        /* const newBOTagsList = BOTagsList.map(tag => {
                            if (tag.number === selectBotagNumber) return { ...tag, selected: true };
                            else return { ...tag, selected: false };
                        });
                        
                        console.log("New BOTAGS from ProductsSidePanel on click outside", newBOTagsList);
                        setBOTagsList(newBOTagsList); */

                        setSidePanelSelectedProductNumber(selectBotagNumber);
                    } else {
                        setSidePanelSelectedProductNumber(undefined);
                        setSidePanelVisible(false);
                    }
                }
            };

            document.addEventListener("click", handleClickOutside);

            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }
    }, [sidePanelVisible]);

    // REMOVES THE NEW LINKED PRODUCTS DOT, when visiting the Linked Products section
    useEffect(() => {
        if (sidePanelSection === "Linked Products") {
            setSidePanelHasNewLinkedProducts(false);
        }
    }, [sidePanelSection]);

    useEffect(() => {
        searchProductsByName(debouncedText);
    }, [debouncedText]);
    /* #endregion */

    /* #region METHODS */
    const toogleSidePanel = (visible = undefined) => {
        const newVisibleState = visible !== undefined ? visible : !sidePanelVisible;
        setSidePanelVisible(newVisibleState);
    };

    const showProducts = () => {
        setSidePanelSection("Products");
    };

    const showLinkedProducts = () => {
        setSidePanelSection("Linked Products");
    };

    const searchProductsByName = debouncedText => {
        setSidePanelProductSearchName(debouncedText);
        //AppQueryClient.invalidateQueries("getProductsForBOimages");
    };

    const onViaFileClicked = () => {
        setBOImageProductsImporting(1);
    };
    /* #endregion */

    return (
        <StyledPage className="SidePanel noOverflow">
            <div className="Frame313346">
                <div className="Rectangle300"></div>
                <div
                    className="Group3497"
                    onClick={() => {
                        toogleSidePanel();
                    }}>
                    <div className="Rectangle253">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="143"
                            viewBox="0 0 29 143"
                            fill="none">
                            <path
                                d="M29 0L7.09899 6.63902C2.88299 7.91704 0 11.8035 0 16.209V127.669C0 132.213 3.06396 136.186 7.45904 137.341L29 143V0Z"
                                fill="#0060CC"
                            />
                        </svg>
                    </div>

                    <div className="ItemsPanel">Items Panel</div>
                </div>
            </div>
            <div className="PanelContainer hidden">
                <div className="Frame313271">
                    <div className="Frame313329">
                        <div className="Settings01 hover-not-allowed text-inactive">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.27273 14.7273C5.39374 15.0015 5.42984 15.3056 5.37637 15.6005C5.3229 15.8954 5.18231 16.1676 4.97273 16.3818L4.91818 16.4364C4.74913 16.6052 4.61503 16.8057 4.52353 17.0265C4.43203 17.2472 4.38493 17.4838 4.38493 17.7227C4.38493 17.9617 4.43203 18.1983 4.52353 18.419C4.61503 18.6397 4.74913 18.8402 4.91818 19.0091C5.08704 19.1781 5.28757 19.3122 5.50829 19.4037C5.72901 19.4952 5.96561 19.5423 6.20455 19.5423C6.44348 19.5423 6.68008 19.4952 6.9008 19.4037C7.12152 19.3122 7.32205 19.1781 7.49091 19.0091L7.54545 18.9545C7.75971 18.745 8.03183 18.6044 8.32674 18.5509C8.62164 18.4974 8.9258 18.5335 9.2 18.6545C9.46888 18.7698 9.6982 18.9611 9.85972 19.205C10.0212 19.4489 10.1079 19.7347 10.1091 20.0273V20.1818C10.1091 20.664 10.3006 21.1265 10.6416 21.4675C10.9826 21.8084 11.4451 22 11.9273 22C12.4095 22 12.8719 21.8084 13.2129 21.4675C13.5539 21.1265 13.7455 20.664 13.7455 20.1818V20.1C13.7525 19.7991 13.8499 19.5073 14.025 19.2625C14.2001 19.0176 14.4448 18.8312 14.7273 18.7273C15.0015 18.6063 15.3056 18.5702 15.6005 18.6236C15.8954 18.6771 16.1676 18.8177 16.3818 19.0273L16.4364 19.0818C16.6052 19.2509 16.8057 19.385 17.0265 19.4765C17.2472 19.568 17.4838 19.6151 17.7227 19.6151C17.9617 19.6151 18.1983 19.568 18.419 19.4765C18.6397 19.385 18.8402 19.2509 19.0091 19.0818C19.1781 18.913 19.3122 18.7124 19.4037 18.4917C19.4952 18.271 19.5423 18.0344 19.5423 17.7955C19.5423 17.5565 19.4952 17.3199 19.4037 17.0992C19.3122 16.8785 19.1781 16.678 19.0091 16.5091L18.9545 16.4545C18.745 16.2403 18.6044 15.9682 18.5509 15.6733C18.4974 15.3784 18.5335 15.0742 18.6545 14.8C18.7698 14.5311 18.9611 14.3018 19.205 14.1403C19.4489 13.9788 19.7347 13.8921 20.0273 13.8909H20.1818C20.664 13.8909 21.1265 13.6994 21.4675 13.3584C21.8084 13.0174 22 12.5549 22 12.0727C22 11.5905 21.8084 11.1281 21.4675 10.7871C21.1265 10.4461 20.664 10.2545 20.1818 10.2545H20.1C19.7991 10.2475 19.5073 10.1501 19.2625 9.97501C19.0176 9.79991 18.8312 9.55521 18.7273 9.27273C18.6063 8.99853 18.5702 8.69437 18.6236 8.39947C18.6771 8.10456 18.8177 7.83244 19.0273 7.61818L19.0818 7.56364C19.2509 7.39478 19.385 7.19425 19.4765 6.97353C19.568 6.7528 19.6151 6.51621 19.6151 6.27727C19.6151 6.03834 19.568 5.80174 19.4765 5.58102C19.385 5.36029 19.2509 5.15977 19.0818 4.99091C18.913 4.82186 18.7124 4.68775 18.4917 4.59626C18.271 4.50476 18.0344 4.45766 17.7955 4.45766C17.5565 4.45766 17.3199 4.50476 17.0992 4.59626C16.8785 4.68775 16.678 4.82186 16.5091 4.99091L16.4545 5.04545C16.2403 5.25503 15.9682 5.39562 15.6733 5.4491C15.3784 5.50257 15.0742 5.46647 14.8 5.34545H14.7273C14.4584 5.23022 14.2291 5.03887 14.0676 4.79497C13.906 4.55107 13.8193 4.26526 13.8182 3.97273V3.81818C13.8182 3.33597 13.6266 2.87351 13.2856 2.53253C12.9447 2.19156 12.4822 2 12 2C11.5178 2 11.0553 2.19156 10.7144 2.53253C10.3734 2.87351 10.1818 3.33597 10.1818 3.81818V3.9C10.1807 4.19253 10.094 4.47834 9.93245 4.72224C9.77092 4.96614 9.54161 5.15749 9.27273 5.27273C8.99853 5.39374 8.69437 5.42984 8.39946 5.37637C8.10456 5.3229 7.83243 5.18231 7.61818 4.97273L7.56364 4.91818C7.39478 4.74913 7.19425 4.61503 6.97353 4.52353C6.7528 4.43203 6.51621 4.38493 6.27727 4.38493C6.03833 4.38493 5.80174 4.43203 5.58102 4.52353C5.36029 4.61503 5.15977 4.74913 4.99091 4.91818C4.82186 5.08704 4.68775 5.28757 4.59625 5.50829C4.50476 5.72901 4.45766 5.96561 4.45766 6.20455C4.45766 6.44348 4.50476 6.68008 4.59625 6.9008C4.68775 7.12152 4.82186 7.32205 4.99091 7.49091L5.04545 7.54545C5.25503 7.75971 5.39562 8.03183 5.44909 8.32674C5.50257 8.62164 5.46647 8.9258 5.34546 9.2V9.27273C5.23022 9.54161 5.03887 9.77093 4.79497 9.93245C4.55107 10.094 4.26526 10.1807 3.97273 10.1818H3.81818C3.33597 10.1818 2.87351 10.3734 2.53253 10.7144C2.19156 11.0553 2 11.5178 2 12C2 12.4822 2.19156 12.9447 2.53253 13.2856C2.87351 13.6266 3.33597 13.8182 3.81818 13.8182H3.9C4.19253 13.8193 4.47834 13.906 4.72224 14.0676C4.96614 14.2291 5.15749 14.4584 5.27273 14.7273Z"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <div className="Products">Products</div>
                        <div className="XClose cursor-pointer" onClick={() => toogleSidePanel(false)}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M6 6L18 18M18 6L6 18"
                                    stroke="#D1D1D1"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="Frame313276">
                        <div className="Frame313330">
                            <div className="Search">
                                <input
                                    type="text"
                                    placeholder="Search products"
                                    className="SearchList Frame48"
                                    onChange={event => setSearchTmpName(event.target.value)}
                                    value={searchTmpName}
                                />
                                <div className="SearchIcon text-default">
                                    <img src={magnifierIcon} alt="Search" />
                                </div>
                            </div>
                            {/* Disabled in BOStageR
                                <div className="IconSearch cursor-pointer">
                                onClick={onViaFileClicked}
                                <div className="Frame29 disabled">
                                    <div className="Upload02 text-default">
                                        <Upload02 width={16} height={16} />
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                        <div className="Frame313333">
                            <div className="TabsMainWindow">
                                <div className={`Frame313332 ${sidePanelSection === "Products" ? "active" : ""}`}>
                                    <div className="ProductsList ListItem" onClick={showProducts}>
                                        PRODUCTS LIST
                                    </div>
                                    <div className="Line5"></div>
                                </div>
                                <div
                                    className={`Frame313332 ${sidePanelSection === "Linked Products" ? "active" : ""}`}>
                                    <div className="LinkedProducts ListItem" onClick={showLinkedProducts}>
                                        LINKED PRODUCTS
                                        <div className={`Ellipse6 ${!sidePanelHasNewLinkedProducts ? "hidden" : ""}`} />
                                    </div>
                                    <div className="Line5"></div>
                                </div>
                            </div>

                            <div
                                className={`InfiniteScrollContainer ${
                                    sidePanelSection === "Products" ? "visible" : "hidden"
                                }`}>
                                {/* data.map(item => (
                                        <div key={item.productID} className="ListItem2">
                                            <ProductCardSidePanel productID={item.productID} isCompletedCard={false} />
                                        </div>
                                    )) */}
                                {/* TODO: HIDE WHEN LOADING */}
                                {/*sidePanelHasNoProducts && !sidePanelProductSearchName && !sidePanelIsLoading && (
                                    <NoProductsWarning
                                        navigate={navigate}
                                        setShowAddProductsPopup={setShowAddProductsPopup}
                                        onViaFileClicked={onViaFileClicked}
                                    />
                                )*/}
                                {sidePanelProducts?.length === 0 &&
                                    //sidePanelProductSearchName &&
                                    !sidePanelIsLoading && (
                                        <label className="text-default">
                                            No products found for your search criteria
                                        </label>
                                    )}

                                {sidePanelRetailBrandID && sidePanelVisible && <InfinityGridSidePanelBOImages />}
                            </div>

                            {sidePanelSection === "Linked Products" && (
                                <div
                                    className={`Frame313311 ${
                                        sidePanelSection === "Linked Products" ? "visible" : "hidden"
                                    }`}>
                                    {BOTagsList.filter(tag => tag.completed).map((item, index) => {
                                        //console.log("KEY:", `${item.data?.productObjID}_${index}`);

                                        return (
                                            <div
                                                key={`${item.data?.productObjID}_${index}`}
                                                className="ListItem2 w-100">
                                                <SidePanelLinkedCard BOTagNumber={item.number} BOTag={item} />
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </StyledPage>
    );
}

export function NoProductsWarning({ navigate, setShowAddProductsPopup, onViaFileClicked }) {
    return (
        <NoProductsWarningStyled className="frame-313311">
            <div className="items-panel-product-card">
                <div className="frame-313313">
                    <div className="frame-313326">
                        <div className="frame-313323">
                            <div className="you-don-t-have-any-products-to-link-select-how-you-want-to-import-products">
                                You don’t have any products to link.
                                <br />
                                Select how you want to import products.
                            </div>
                        </div>
                    </div>
                    <div className="frame-313328">
                        <div className="frame-295922380">
                            <BtnLargeSolidInverted02
                                text="via file"
                                //disabled={true}
                                onClick={() => {
                                    //navigate("/products/add");
                                    if (onViaFileClicked) {
                                        onViaFileClicked();
                                    }
                                }}
                            />
                            <BtnLargeSolidInverted02
                                text="via server"
                                onClick={() => {
                                    setShowAddProductsPopup(true);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </NoProductsWarningStyled>
    );
}
